import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
  padding-top: 16px;
`;

export const LinkWrapper = styled.div`
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    text-align: end;
  }
`;

export const RankingSubtitle = styled.span`
  font-size: 16px;
  font-weight: 500;
`;

export const RankingCategory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ul {
    list-style: disc;
    padding-top: 0;
    margin-top: 0;
    padding-left: 20px;
  }
`;

export const RankingCategoryContent = styled.div`
  display: flex;
  flex-direction: column;
`;
